module.exports = __webpack_public_path__ + "img/bingo_ball-21.d5dcf189.png";